import { SET_IS_LOADING_LOGS, SET_NO_RESULT_FOUND  } from "redux/constants/portal";

const initialState = {
  isLoadingLogs: false,
  noResultFound: false,
};

const logs = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_IS_LOADING_LOGS:
      return {
        ...state,
        isLoadingLogs: payload,
      };
    case SET_NO_RESULT_FOUND:
      return {
        ...state,
        noResultFound: payload,
      };
    default:
      return state;
  }
};

export default logs;
